import {React,useEffect } from "react";
import { useSelector } from "react-redux";
import PublHomeData from "./PublHomeData";
import { useNavigate } from "react-router-dom";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { LuShoppingBag } from "react-icons/lu";

export default function CategoryBody() {
    const nav = useNavigate();
    useEffect(() => {
  window.scrollTo(0, 0);
}, []);

    const categorys = useSelector(state => state.dropdown.category);

    const filteredProducts = PublHomeData.filter(
        product => product.category === categorys && !product.outOfStock
    );

    const handlePlaceOrder = () => {
        nav("/login");
    };

    const handleCallUs = () => {
        // Replace with your actual phone number
        window.location.href = "tel:+919906644334";
    };

    const noSelectStyle = {
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        OUserSelect: "none"
    };

    // Inline styles object for the card and video player
    const cardStyle = {
        width: "24rem", // Made bigger as requested
        ...noSelectStyle,
        border: "none",
        borderRadius: "1.5rem",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        overflow: "hidden"
    };

    const videoContainerStyle = {
        position: "relative",
        paddingBottom: "65%", // 16:9 Aspect Ratio
        height: 0,
        overflow: "hidden"
    };

 

    return (
        <div className="container-fluid mt-5 mb-5" style={noSelectStyle}>
            <div className="row justify-content-center">
                {filteredProducts.map((product, index) => (
                    <div
                        className="col-lg-4 col-md-4 col-sm-12 mb-4 d-flex justify-content-center"
                        key={index}
                        data-aos="fade-up"
                        data-aos-delay={index * 100}
                    >
                        {/* Conditional Rendering based on category */}
                       {product.category === "Hamper Packages" ? (
    <div className="card h-100" style={cardStyle}>
        <div style={videoContainerStyle}>
            <video
                src={product.videoUrl}
                autoPlay
                muted
                loop
                playsInline
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // fills the space without black bars
                    borderRadius: "1.5rem"
                }}
                controls={false} // hide controls
                onContextMenu={(e) => e.preventDefault()} // disable right click
            />
        </div>
        <div className="card-body d-flex flex-column" style={noSelectStyle}>
            <h4
                className="card-title"
                style={{
                    fontFamily: "'Playfair Display', serif",
                    color: "#13547a",
                    fontWeight: "bold",
                    fontSize: "1.7rem",
                    letterSpacing: "1px",
                    textShadow: "1px 2px 8px #d8eaf3"
                }}
            >
                {product.name}
            </h4>
            <h5
                className="card-text"
                style={{
                    fontFamily: "'Open Sans', sans-serif",
                    color: "#666",
                    fontStyle: "italic",
                    fontSize: "1.05rem",
                    marginTop: "0.6rem",
                    marginBottom: "1.1rem",
                    borderRadius: "8px",
                    padding: "8px 14px",
                    backgroundColor: "transparent"
                }}
            >
                {product.descrption}
            </h5>
           
            <div className="d-flex flex-column align-items-center">
                <button
                    type="button"
                    className="btn btn-outline-primary mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                    onClick={handleCallUs}
                >
                    📞 Call Us
                </button>
            </div>
        </div>
    </div>
) : (
                            // Original card for all other categories
                            <div className="card h-100" style={{ ...cardStyle, width: "18rem" }}>
                                <img
                                    src={product.img}
                                    className="card-img-top"
                                    alt={product.name}
                                    style={{ height: "200px", objectFit: "cover", ...noSelectStyle }}
                                />
                                <div className="card-body d-flex flex-column" style={noSelectStyle}>
                                    <h4
                                        className="card-title"
                                        style={{
                                            ...noSelectStyle,
                                            fontFamily: "'Playfair Display', serif",
                                            color: "#13547a",
                                            fontWeight: "bold",
                                            fontSize: "1.7rem",
                                            letterSpacing: "1px",
                                            textShadow: "1px 2px 8px #d8eaf3"
                                        }}
                                    >
                                        {product.name}
                                    </h4>
                                    <h5
                                        className="card-text"
                                        style={{
                                            ...noSelectStyle,
                                            fontFamily: "'Open Sans', sans-serif",
                                            color: "#666",
                                            fontStyle: "italic",
                                            fontSize: "1.05rem",
                                            marginTop: "0.6rem",
                                            marginBottom: "1.1rem",
                                            borderRadius: "8px",
                                            padding: "8px 14px",
                                            backgroundColor: "transparent"
                                        }}
                                    >
                                        {product.descrption}
                                    </h5>
                                    <h4
                                        className="card-text"
                                        style={{
                                            ...noSelectStyle,
                                            color: "#21b573",
                                            fontSize: "1.2rem",
                                            marginTop: "0.5rem",
                                            fontWeight: "600",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px"
                                        }}
                                    >
                                        Price: <FaIndianRupeeSign style={{ color: "#21b573", fontSize: "1.1rem" }} /> {product.price}
                                    </h4>   <h6 className="card-text">Including GST, shipping & packaging</h6>
                                    <h5 style={{   
                                         fontSize: "1.08rem",
                                       color: "#444",
                                      fontWeight: "600",
                                      letterSpacing: "0.3px",
                                        marginTop: "0.4rem"
       
                                      }} >Quantity: {product.weight}</h5>
                                    <div className="d-flex flex-column align-items-center" style={noSelectStyle}>
                                        <button
                                            type="button"
                                            className="btn btn-outline-success mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                                            onClick={() => handlePlaceOrder(product)}
                                            style={noSelectStyle}
                                        >
                                            <LuShoppingBag /> Place Order
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}